import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';





const columns = [
  {
    title: 'Asset Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Acquisition Date',
    dataIndex: 'acquisition_date',
    key: 'acquisition_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${new Date(record.acquisition_date).toLocaleDateString()}`}</span>
  },
  {
    title: 'Method',
    dataIndex: 'method',
    key: 'method',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'running' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'done' ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/assets/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

const periods = [{value: 'years', label: 'Year(s)'}, {value: 'months', label: 'Month(s)'}, {value: 'week', label: 'Week(s)'}];

// const depreciationBoard = [
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'declining'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'declining'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
//   {name: 'Computer', date: '12/12/2021', depreciation: 300, method: 'straight line'},
// ]

const Assets = () => {
  const assets = useLoaderData();
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Assets</h3>
        <div className='bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/assets/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        dataSource={assets}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Assets;